<section class="legal-section modern-section section-first" #legalRoot>
  <div class="container px-5">
    <div class="row justify-content-center mb-5">
      <div class="col-lg-8 text-center">
        <div class="section-head reveal-on-scroll" data-reveal="section-head" data-reveal-trigger="immediate">
          <h1 class="modern-section-title">Términos de <span class="highlight-green">Servicio</span></h1>
          <div class="section-underline"></div>
          <p class="modern-section-desc mb-0">Última actualización: 2026</p>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="glass-card text-light lh-lg reveal-on-scroll" data-reveal="card" style="--reveal-order: 1">
          <div class="legal-notice">
            <strong>Identidad del prestador.</strong> El sitio web grupodingo.com.mx y los servicios ofrecidos bajo la
            marca <strong>Grupo DINGO</strong> son operados bajo la marca comercial <strong>DINGO</strong>, la cual es
            propiedad de <strong>Pleiades Investment Solutions</strong>. La entidad legal que presta los servicios y que
            consta en acta constitutiva, constancias fiscales y documentación oficial es Pleiades Investment Solutions.
            Cualquier referencia a "Grupo DINGO", "DINGO" o "nosotros" en estos términos se refiere a la operación de dicha
            marca por parte de Pleiades Investment Solutions.
          </div>

          <h2 class="text-primary-green fs-5 fw-bold mb-2">1. Aceptación de los términos</h2>
          <p class="mb-3">
            Al acceder y utilizar este sitio web y los servicios de la marca Grupo DINGO, aceptas estos Términos de
            Servicio. Si no estás de acuerdo, no utilices el sitio ni los servicios.
          </p>

          <h2 class="text-primary-green fs-5 fw-bold mt-4 mb-2">2. Descripción del servicio</h2>
          <p class="mb-3">
            Grupo DINGO (operado por Pleiades Investment Solutions) ofrece servicios de agencia omnicanal, central de
            medios, marketing digital, desarrollo web y de aplicaciones, publicidad, data science, business intelligence,
            fintech, blockchain y relacionados. La oferta concreta se define en propuestas, contratos o acuerdos
            particulares con cada cliente.
          </p>

          <h2 class="text-primary-green fs-5 fw-bold mt-4 mb-2">3. Uso del sitio</h2>
          <p class="mb-3">
            Te comprometes a utilizar el sitio de forma lícita, sin vulnerar derechos de terceros ni las leyes aplicables.
            No está permitido el uso del sitio para fines fraudulentos, difamatorios o que dañen la infraestructura o la
            reputación de Pleiades Investment Solutions o de la marca DINGO.
          </p>

          <h2 class="text-primary-green fs-5 fw-bold mt-4 mb-2">4. Propiedad intelectual</h2>
          <p class="mb-3">
            Los contenidos, marcas, logotipos y materiales del sitio son propiedad de Pleiades Investment Solutions o de
            sus licenciantes. La marca DINGO y Grupo DINGO son marcas de Pleiades Investment Solutions. No se concede
            ninguna licencia implícita para usar dichos elementos fuera del uso normal del sitio.
          </p>

          <h2 class="text-primary-green fs-5 fw-bold mt-4 mb-2">5. Contratación y condiciones comerciales</h2>
          <p class="mb-3">
            La contratación de servicios se rige por los acuerdos específicos que se celebren con Pleiades Investment
            Solutions. Los precios, plazos y condiciones se establecerán en propuestas o contratos por escrito. La relación
            contractual es entre el cliente y Pleiades Investment Solutions como entidad legal.
          </p>

          <h2 class="text-primary-green fs-5 fw-bold mt-4 mb-2">6. Limitación de responsabilidad</h2>
          <p class="mb-3">
            En la medida permitida por la ley, Pleiades Investment Solutions no será responsable por daños indirectos,
            consecuentes o punitivos derivados del uso del sitio o de los servicios. La responsabilidad se limitará a lo
            previsto en los contratos específicos con cada cliente.
          </p>

          <h2 class="text-primary-green fs-5 fw-bold mt-4 mb-2">7. Modificaciones</h2>
          <p class="mb-3">
            Nos reservamos el derecho de modificar estos Términos de Servicio. Los cambios entrarán en vigor al
            publicarse en esta página. El uso continuado del sitio tras la publicación constituye la aceptación de los
            nuevos términos.
          </p>

          <h2 class="text-primary-green fs-5 fw-bold mt-4 mb-2">8. Contacto y ley aplicable</h2>
          <p class="mb-3">
            Para cualquier cuestión relacionada con estos términos o con la relación legal con Pleiades Investment
            Solutions, puedes contactarnos en <a href="mailto:contacto&#64;grupodingo.com.mx" class="text-primary-green text-decoration-underline">contacto&#64;grupodingo.com.mx</a>.
            Estos términos se rigen por las leyes de los Estados Unidos Mexicanos. Cualquier controversia se someterá a
            los tribunales competentes en la Ciudad de México.
          </p>

          <a routerLink="/inicio" class="d-inline-flex align-items-center gap-2 text-primary-green fw-semibold text-decoration-none mt-4">
            <i class="bi bi-arrow-left"></i> Volver al inicio
          </a>
        </div>
      </div>
    </div>
  </div>
</section>
